import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Brain, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../services/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    try {
      setIsLoading(true);
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      toast.error('Error al enviar el email');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4"
         style={{ background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 50%, #1e1b4b 100%)' }}>
      <div className="w-full max-w-md glass-container">
        <div className="text-center mb-8">
          <Brain className="w-12 h-12 text-yellow-400 mx-auto mb-3" />
          <h1 className="text-2xl font-bold text-white">¿Olvidaste tu contraseña?</h1>
          <p className="text-white/60 mt-2 text-sm">
            Introduce tu email y te enviaremos un enlace de recuperación
          </p>
        </div>

        {sent ? (
          <div className="text-center">
            <div className="text-5xl mb-4">📬</div>
            <h2 className="text-lg font-semibold text-white mb-2">Email enviado</h2>
            <p className="text-white/60 text-sm mb-6">
              Si el email está registrado, recibirás las instrucciones en breve.
              Revisa también tu carpeta de spam.
            </p>
            <Link to="/login" className="text-purple-400 hover:text-purple-300 text-sm flex items-center justify-center gap-1">
              <ArrowLeft className="w-4 h-4" /> Volver al login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">
                <Mail className="w-4 h-4 inline mr-2" />
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="input-neureka"
                placeholder="tu@email.com"
                required
                disabled={isLoading}
              />
            </div>

            <button
              type="submit"
              disabled={isLoading || !email}
              className="btn-primary w-full"
            >
              {isLoading ? 'Enviando...' : 'Enviar enlace de recuperación'}
            </button>

            <Link to="/login" className="text-white/50 hover:text-white/80 text-sm flex items-center justify-center gap-1 mt-2">
              <ArrowLeft className="w-4 h-4" /> Volver al login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
